import React from "react";
import Dropzone from 'react-dropzone'
import Cropper from 'react-cropper';
import Modal from "./Modal.jsx";
import 'cropperjs/dist/cropper.css'
import { dataURLtoFile } from "../utils/functions.js";
import { checkTranslation } from "../utils/useful.js";

class CustomDropZone extends React.Component {


    state = {

    }

    render() {
        const dropzoneRef = React.createRef();
        let info = this.props.information

        return (
            <div >

                <Dropzone
                    ref={dropzoneRef}
                    multiple={false}
                    accept={this.props.isImage ? 'image/jpeg,image/png' : null}
                    onDrop={this.onDrop.bind(this)}
                    style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                >
                    {({ getRootProps, getInputProps }) => (

                        <div className=" w-100 h-100 outline-none" {...getRootProps()}>
                            <input {...getInputProps()} />
                            {this.props.children}
                        </div>

                    )}

                </Dropzone>



                <Modal className="" ref={el => this.croperModal = el} maxWidth={700} style={{}}>

                    <div className="pt-2 pb-3" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <Cropper
                            ref={el => this.cropper = el}
                            src={this.state.image}
                            style={{ maxHeight: 400, maxWidth: '100%' }}
                            aspectRatio={info.ratio ? (info.ratio.split(':')[0] / info.ratio.split(':')[1]) : null}
                            guides={true}
                            zoomable={false}
                            background={true}
                            backgroundColor={"#fff"}
                        />

                        <div className=" ml-auto mr-auto  mt-3 mb-4" style={{ textAlign: 'center', marginBottom: 0 }}>
                            <button onClick={() => { this.croperModal.hideModal(); this._crop(); }} style={{ borderRadius: 30, fontSize: 15, fontWeight: 'bold', padding: '5px 15px', backgroundColor: '#202020', color: '#fff' }}>{checkTranslation("Add Image")}</button>
                        </div>
                    </div>
                </Modal>



            </div>

        );
    }


    onDrop(filesInputs) {

        if (this.props.information.cropper && filesInputs[0].type == 'image/jpeg') {
            if (filesInputs[0].type == 'image/jpeg') {
                this.setState({ image: URL.createObjectURL(filesInputs[0]) }, () => {
                    this.croperModal.showModal()
                })
            }
        } else {

            let newImages = []

            filesInputs.forEach(filesInput => {
                if (filesInput.type == 'image/jpeg' || filesInput.type == 'image/png') {
                    newImages.push(URL.createObjectURL(filesInput))
                } else {
                    newImages.push(null)
                }
            });

            this.props.onDrop(filesInputs, newImages)
        }
    }


    _crop() {

        let image = this.cropper.getCroppedCanvas().toDataURL('image/jpeg', 1)
        // images.push(dataURL)
        let file = dataURLtoFile(image, 'image.jpg');
        // files.push(file)
        this.props.onDrop([file], [image])

        // this.props.changeFiles(files, this.props.headerkey, 'file')
    }


}

export default CustomDropZone;
